import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import { createUseStyles } from 'react-jss';
import { ThemeContext } from 'styled-components';

import { Picture } from '@comparethemarketau/manor-picture';

import { getAssetFilePath } from '../../summary/common/get_asset_file_path';

const useStyles = createUseStyles((theme) => ({
    container: {
        width: '8rem',
        height: '4.8rem',
        objectFit: 'scale-down',
        objectPosition: 'center'
    }
}));

// https://ctmaus.atlassian.net/browse/SML-2070
// Logo container in Product card feature is resized to 80 x 48 px (default)
// Logo container in Product intro card(Comparison page) feature is resized to 45 x 27 px

const ProviderLogo = (props) => {
    const { code, className, isCustomerStyle, containerSize } = props;
    const theme = useContext(ThemeContext);
    const classes = useStyles({ theme });

    return (
        <Picture
            className={classNames(`test-providerLogo-${code}`, !isCustomerStyle && classes.container, className)}
            alt={`${(providerMap[code] || '')} Company Logo`}
            {...getPictureSource(code, containerSize)}
        />
    );
};

const getPictureSource = (providerCode, containerSize) => {
    const svgSupported = SVG_SUPPORTED.includes(providerCode);
    const folderPrefix = '/assets/images/logos/car-insurance/high-quality';

    const getPNG = (ratio) => getAssetFilePath(`${folderPrefix}/${containerSize}/${providerCode}@${ratio}.png`);
    const getSvg = () => getAssetFilePath(`${folderPrefix}/${providerCode}.svg`);

    const buildSrcsets = () => {
        return svgSupported ? undefined : [
            {
                srcset: `${getPNG('1x')} 1x, ${getPNG('2x')} 2x`
            }
        ];
    };

    return {
        src: svgSupported
            ? getSvg()
            : getPNG('2x'),
        srcsets: buildSrcsets()
    };
};

ProviderLogo.propTypes = {
    /**
     * Provider code, for example: CARP
     */
    code: PropTypes.string.isRequired,
    className: PropTypes.string,
    isCustomerStyle: PropTypes.bool,
    containerSize: PropTypes.oneOf(['80x48', '65x39'])
};

ProviderLogo.defaultProps = {
    isCustomerStyle: false,
    containerSize: '80x48'
};

export { ProviderLogo, getPictureSource };

const SVG_SUPPORTED = ['STEL', '1FOW', 'BUDD', 'HUDD', 'EXIG', 'OZIC',
    'VIRG', 'RETI', 'WOOL', 'EXOA', 'PROG', 'BUPA', 'AHM', 'EXCL'];

export const providerMap = {
    '1FOW': '1st for Women',
    BUDD: 'Budget Direct',
    CARP: 'Carpeesh',
    EXIG: 'ING',
    EXOA: 'Oceania Insurance',
    EXPO: 'Australia Post',
    EXCL: 'Coles Insurance',
    HUDD: 'Huddle Insurance',
    OZIC: 'Ozicare',
    REAL: 'Real Insurance',
    RETI: 'Retirease',
    STEL: 'Stella',
    VIRG: 'Virgin Money',
    WOOL: 'Woolworths Car Insurance',
    PROG: 'Progressive',
    BUPA: 'Bupa',
    AHM: 'ahm'
};
